























import { Severity } from '@sentry/types';

export enum ESteps {
  Stations = 'station',
  Soles = 'soles',
  Acquisition = 'acquisition',
  VionicQuestions = 'vionicAnswers',
  Speed = 'speed',
  Timer = 'timer',
}
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { EAcquisitionModule } from '@/plugins/podolib/services/helper/mixins/acquisition/step';

@Component
export default class DialogAcquisitionInProgress extends Vue {
  @Prop({ default: true }) openDialog!: boolean;

  @Provide() patientLoaded: boolean = false;
  @Provide() commandResumed: any = null;
  @Provide() acquisitionModule: EAcquisitionModule | null = null;
  @Provide() acquisition: any = {
    steps: [],
  };

  // Take over the in-progress acquisition
  resumeAcquisition() {
    this.closeAnalysisDialog();
    this.$router.push({ path: '/analysis', query: { patientId: this.$pdc.analysis!.patientId } });
  }
  startAcquisition(type: any) {
    this.acquisitionModule = type;
    switch (type) {
      /*case EAcquisitionModule.Vionic:
          this.acquisition = {
            steps: [
              {
                name: ESteps.VionicQuestions,
                completed: false,
                component: 'AcquisitionStepVionicAnswers',
                data: null
              },
              {
                name: ESteps.Stations,
                completed: false,
                component: 'AcquisitionStepStation',
                data: null
              },
              {
                name: ESteps.Soles,
                completed: false,
                component: 'AcquisitionStepSoles',
                data: null
              },
              {
                name: ESteps.Acquisition,
                completed: false,
                component: 'AcquisitionStepAcquisition',
                data: null
              }
            ]
          };
          break;*/
      case EAcquisitionModule.RunningTreadmill:
        this.acquisition = {
          steps: [
            {
              name: ESteps.Stations,
              completed: false,
              component: 'AcquisitionStepStation',
              data: null,
            },
            {
              name: ESteps.Soles,
              completed: false,
              component: 'AcquisitionStepSoles',
              data: null,
            },
            {
              name: ESteps.Speed,
              completed: false,
              component: 'AcquisitionStepRunningTreadmill',
              data: null,
            },
            {
              name: ESteps.Timer,
              completed: false,
              component: 'AcquisitionStepRunningTimer',
              data: null,
            },
            {
              name: ESteps.Acquisition,
              completed: false,
              component: 'AcquisitionStepAcquisition',
              data: null,
            },
          ],
        };
        break;
      case EAcquisitionModule.RunningOutdoor:
        this.acquisition = {
          steps: [
            {
              name: ESteps.Stations,
              completed: false,
              component: 'AcquisitionStepStation',
              data: null,
            },
            {
              name: ESteps.Soles,
              completed: false,
              component: 'AcquisitionStepSoles',
              data: null,
            },
            {
              name: ESteps.Timer,
              completed: false,
              component: 'AcquisitionStepRunningTimer',
              data: null,
            },
            {
              name: ESteps.Acquisition,
              completed: false,
              component: 'AcquisitionStepAcquisition',
              data: null,
            },
          ],
        };
        break;
      default:
        this.acquisition = {
          steps: [
            {
              name: ESteps.Stations,
              completed: false,
              component: 'AcquisitionStepStation',
              data: null,
            },
            {
              name: ESteps.Soles,
              completed: false,
              component: 'AcquisitionStepSoles',
              data: null,
            },
            {
              name: ESteps.Acquisition,
              completed: false,
              component: 'AcquisitionStepAcquisition',
              data: null,
            },
          ],
        };
    }
  }

  async cancelAcquisitions() {
    await this.$pdc.analysis!.cancelAnalysis();
    this.$pdc.analysis!.clean();
    this.closeAnalysisDialog();
  }

  closeAnalysisDialog() {
    this.$emit('closeAnalysisDialog');
  }
}
